module.exports = __webpack_public_path__ + "static/media/Pfizer.b63fceff.png";